/**
 * 模块说明：变更单
 */
import { Service } from '@/tools'
export class OrderChangeServer<T extends TOrder.ChangeOrder> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.ChangeOrder}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  private postUpload<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.ChangeOrder}`, data?: TCommon.Json, toast?: string) {
    return this.post(
      {
        url: url,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        method: 'post',
        data: data,
      },
      data,
      toast
    )
  }
  // 销售订单变更单列表分页 /api/order/change/v1/pageChanges
  pageChanges = <K extends T['ApiPageChanges']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPageChanges', data)

  //销售订单变更单详情 /api/order/change/v1/queryChangeDetail
  queryChangeDetail = <K extends T['ApiQueryChangeDetail']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryChangeDetail', data)
  //销售订单变更单关闭 /api/order/change/v1/updateCloseChange
  updateCloseChange = <K extends T['ApiUpdateCloseChange']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateCloseChange', data)

  //销售订单变更单详情商品列表分页 /api/order/change/v1/pageChangeProduct
  pageChangeProduct = <K extends T['ApiPageChangeProduct']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPageChangeProduct', data)

  //省店业务-销售订单变更单-新增/api/order/change/v1/provincialStoreInsertChange
  provincialStoreInsertChange = <K extends T['ApiProvincialStoreInsertChange']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiProvincialStoreInsertChange', data)
}
